// components/Students/AddStudentPage.js
import React, { useEffect, useState } from "react";
import StudentForm from "./StudentForm";
import apiClient from "../../utils/apiClient";
import { useNavigate } from "react-router-dom";

const initialForm = {
  name: "",
  email: "",
  mobile: "",
  dob: "",
  gender: "",
  address: "",
  course: "",
  batch: "",
  degree: "",
  passout: "",
  experience: "",
  totalFees: "",
  paidFees: "",
  pendingFees: "",
  placement: "Yes",
  refName: "",
  refNumber: "",
  comments: "",
};

const AddStudentPage = () => {
  const [toast, setToast] = useState({ show: false, message: "", type: "success" });
  const [loading, setLoading] = useState(false);
  const [courseOptions, setCourseOptions] = useState([]);
  const [batchOptions, setBatchOptions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const { data } = await apiClient.get("/courses/list");
        setCourseOptions((data.courses || []).map(c => ({ value: c._id, label: c.name, fees: c.fees || c.price || '' })));
      } catch {
        setCourseOptions([]);
      }
    };
    fetchCourses();
  }, []);

  const fetchBatches = async (courseId) => {
    if (!courseId) return setBatchOptions([]);
    try {
      const { data } = await apiClient.get("/batches/list", { params: { course: courseId } });
      setBatchOptions((data.batches || []).map(b => ({ value: b._id, label: b.name })));
    } catch {
      setBatchOptions([]);
    }
  };

  const handleAdd = async (formData, additionalCourses = []) => {
    setLoading(true);
    try {
      const payload = { ...formData };
      if (!payload.course) payload.course = null;
      if (!payload.batch) payload.batch = null;
      // Include additional courses in payload
      if (additionalCourses.length > 0) {
        payload.additionalCourses = additionalCourses.filter(ac => ac.courseId);
      }
      await apiClient.post("/students/add", payload);
      setToast({ show: true, message: "Student added successfully!", type: "success" });
      setTimeout(() => navigate("/students"), 1200);
    } catch (error) {
      console.error("Error adding student:", error);
      const apiMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Failed to add student.";
      setToast({ show: true, message: apiMessage, type: "error" });
    }
    setLoading(false);
  };

  return (
    <StudentForm
      initialData={initialForm}
      courseOptions={courseOptions}
      batchOptions={batchOptions}
      loading={loading}
      toast={toast}
      setToast={setToast}
      mode="add"
      onSubmit={handleAdd}
      onChangeCourse={fetchBatches}
    />
  );
};

export default AddStudentPage;
